import { define, prop } from "@/components/builder/utils"

import BasePreview from "./base"

function HbsVariablePreview({ content, ...props }) {
  return <BasePreview {...props}>
    <div>
      {content}
    </div>
  </BasePreview>
}

function HbsVariableHTML({ html, attributes }) {
  return <div {...attributes}>
    {html}
  </div>
}

export default define('hbs-variable', HbsVariablePreview, HbsVariableHTML)
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.typography())
  .property(prop.predefined.paragraphSpacing())
  .property(prop.predefined.textAlignContainer())
  .build()
